import React, { useCallback, useEffect, useRef, useState } from "react";

import {
    Content,
    ContentBody,
    DialogTop,
    DialogTopLeft,
    DialogTopCenter,
    DialogTopRight,
    IconHeader,
    ContainerList,
    AutomaticData,
    SubTitle,
    Description,
    ContentDescription,
    ContainerFields,
    RegisterData
} from "./style";

import { Dialog } from '@material-ui/core';
import { AiOutlineClose } from "react-icons/ai";
import api from "../../services/api";
import List from "../../components/List";
import ListItem from "../../components/List/ListItem";
import ListColumn from "../../components/List/ListColumn";
import ListText from "../../components/List/ListText";
import { BalanceTransaction } from "../../interfaces/BalanceTransaction";
import debounce from "lodash.debounce";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BsArrowLeftRight } from "react-icons/bs";

interface BalanceTransactionDialogProps {
    open: boolean;
    field_id: number;
    form_answer_field_id: number;
    onClose: () => void;
}

const BalanceTransactionDialog: React.FC<BalanceTransactionDialogProps> = ({ onClose, open, field_id, form_answer_field_id }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [transactions, setTransactions] = useState<BalanceTransaction[]>([]);
    const [page, setPage] = useState<number>(1);
    const [hasMore, setHasMore] = useState(true);
    const parentRef = useRef<HTMLDivElement | null>(null);

    const handleClose = useCallback(async () => {
        onClose();
    }, [onClose]);

    // Função para buscar dados
    const fetchData = async (pageToLoad: number, resetHasMore?: boolean) => {
        setLoading(true);
        setPage(pageToLoad);

        try {

            if (resetHasMore) {
                setHasMore(true);
            }

            const response = await api.post(`/transaction/p/all`, {
                page: pageToLoad,
                field_id: field_id,
                form_answer_field_id: form_answer_field_id
            });

            if (response.data && response.data.length > 0) {
                const transactionsApi: BalanceTransaction[] = response.data;

                if (pageToLoad === 1) {
                    setTransactions(transactionsApi);
                } else {
                    setTransactions((prevData) => [...prevData, ...transactionsApi]);
                }
            } else {

                if (pageToLoad === 1) {
                    setTransactions([]);
                } else {
                    setHasMore(false);
                }

            }
        } catch (error) {
            console.error("Error loading data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Debounce para o evento de scroll
    const handleScroll = debounce(() => {
        if (parentRef.current && hasMore && !loading) {
            const { scrollTop, scrollHeight, clientHeight } = parentRef.current;

            // Se o usuário está próximo do fim da lista, carrega mais dados
            if (scrollTop + clientHeight >= scrollHeight - 300) {
                fetchData(page + 1);
            }
        }
    }, 200);


    useEffect(() => {

        if (open) {
            //Just one time
            fetchData(1, true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <Dialog
            fullWidth={true}
            maxWidth="lg"
            open={open}
            onClose={handleClose}
        >
            <DialogTop>
                <DialogTopLeft>
                    <IconHeader color={"gray"}>
                        <div>
                            <BsArrowLeftRight />
                        </div>
                    </IconHeader>
                    <h1>
                        {"Movimentações do registro"}
                    </h1>
                </DialogTopLeft>

                <DialogTopCenter />

                <DialogTopRight>
                    <button onClick={handleClose}><AiOutlineClose /></button>
                </DialogTopRight>
            </DialogTop>

            <Content>
                <ContentBody container>

                    <ContentDescription>
                        <SubTitle>
                            {"Histórico de movimentações"}
                        </SubTitle>
                        <Description>
                            {"Este é o histórico movimentações (entradas e saídas) do seu registro. O tipo saldo inicial significa que o saldo foi substituído por outro valor via automação ou alteração direto no campo do formulário."}
                        </Description>
                    </ContentDescription>

                    <ContainerFields item xs={12} md={12} lg={12} sm={12}>

                        <ContainerList
                            ref={parentRef}
                            onScroll={handleScroll}
                            style={{ height: "100%", overflowY: "auto" }}
                        >
                            <List style={{ minWidth: '1600px' }}>
                                <ListItem>
                                    <ListColumn>
                                        <ListText header>
                                            Identificador
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Data
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Tipo
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Quantidade
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn>
                                        <ListText header>
                                            Origem
                                        </ListText>
                                    </ListColumn>
                                    <ListColumn flex flexGrow={5}>
                                        <ListText header>
                                            Observação
                                        </ListText>
                                    </ListColumn>
                                </ListItem>
                                {transactions.map((rowData, index) => (
                                    <ListItem key={index}>
                                        <ListColumn>
                                            <ListText>
                                                <AutomaticData>
                                                    {"#" + rowData.id_balance_transaction}
                                                </AutomaticData>
                                            </ListText>
                                        </ListColumn>
                                        <ListColumn>
                                            <ListText>
                                                {new Date(rowData.date).toLocaleDateString('pt-BR')}
                                            </ListText>
                                        </ListColumn>
                                        <ListColumn style={{ backgroundColor: rowData.type === "E" ? "#deffde" : rowData.type === "S" ? "#ffa9a9" : rowData.type === "R" ? "#f4f5f7" : "" }}>
                                            <ListText>
                                                {rowData.type === "E" ? "Entrada" : rowData.type === "S" ? "Saída" : rowData.type === "R" ? "Saldo Inicial" : ""}
                                            </ListText>
                                        </ListColumn>
                                        <ListColumn style={{ backgroundColor: rowData.type === "E" ? "#deffde" : rowData.type === "S" ? "#ffa9a9" : rowData.type === "R" ? "#f4f5f7" : "" }}>
                                            <ListText>
                                                {rowData.amount}
                                            </ListText>
                                        </ListColumn>
                                        <ListColumn>
                                            <RegisterData>
                                                {rowData.origin}
                                                <FaExternalLinkAlt style={{ marginLeft: '10px', fontSize: '11px' }} />
                                            </RegisterData>
                                        </ListColumn>
                                        <ListColumn flex flexGrow={5} aglinItems="flex-start">
                                            <ListText>
                                                {rowData.description}
                                            </ListText>
                                        </ListColumn>
                                    </ListItem>
                                ))}

                                {loading && (
                                    <ListItem>
                                        <ListColumn flex flexGrow={15}>
                                            Carregando...
                                        </ListColumn>
                                    </ListItem>
                                )}

                                {transactions !== undefined && transactions.length === 0 &&
                                    <ListItem>
                                        <ListColumn>
                                            <ListText>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px' }}>
                                                    {"Nenhuma transação encontrada. Crie novas automações para controlar o saldo deste campo."}
                                                </div>
                                            </ListText>
                                        </ListColumn>
                                    </ListItem>
                                }
                            </List>
                        </ContainerList>
                    </ContainerFields>
                </ContentBody>
            </Content>
        </Dialog >
    );

}

export default BalanceTransactionDialog;